import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueClipboard from 'vue-clipboard2'

import firebase from 'firebase'

Vue.config.productionTip = false

// Your web app's Firebase configuration

var firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: "block-de-notas-clujan.firebaseapp.com",
    databaseURL: "https://block-de-notas-clujan.firebaseio.com",
    projectId: "block-de-notas-clujan",
    storageBucket: "block-de-notas-clujan.appspot.com",
    messagingSenderId: "826245975538",
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASURE_ID
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

/* Variable global */
Vue.prototype.$db = firebase.firestore()

Vue.use(VueClipboard);

firebase.auth().onAuthStateChanged(function (user) {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})

